import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Layout } from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { useLanguage } from '../contexts/LanguageContext';
import { Dialog, DialogContent } from '../components/ui/dialog';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SizeGuide() {
  const { t } = useLanguage();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [zoomedImage, setZoomedImage] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await axios.get(`${API}/api/settings/size-guide-images`, { withCredentials: true });
        setImages(res.data.images || []);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetchImages();
  }, []);

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-96">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900 mx-auto" />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-5xl mx-auto space-y-6">
        <h1 data-testid="size-guide-title" className="text-2xl font-semibold text-slate-900 tracking-tight">
          {t('size_guide')}
        </h1>
        <p className="text-sm text-slate-600">{t('size_guide_desc')}</p>

        {images.length === 0 ? (
          <Card className="border-slate-200 shadow-sm">
            <CardContent className="py-12 text-center text-sm text-slate-500">
              {t('no_image')}
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {images.map((url, idx) => (
              <Card key={`sg-${url.slice(-20)}-${idx}`} className="border-slate-200 shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition-shadow" onClick={() => setZoomedImage(url)}>
                <CardContent className="p-2">
                  <img
                    data-testid={`size-guide-image-${idx}`}
                    src={url}
                    alt={`Size guide ${idx + 1}`}
                    className="w-full h-auto rounded object-contain"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                </CardContent>
              </Card>
            ))}
          </div>
        )}

        <Dialog open={!!zoomedImage} onOpenChange={() => setZoomedImage(null)}>
          <DialogContent className="max-w-[90vw] max-h-[90vh] p-2">
            {zoomedImage && (
              <img src={zoomedImage} alt="Size guide zoom" className="w-full h-auto max-h-[85vh] object-contain" />
            )}
          </DialogContent>
        </Dialog>
      </div>
    </Layout>
  );
}
